import { render, staticRenderFns } from "./HKIndex_page.vue?vue&type=template&id=563c2d17&scoped=true"
import script from "./HKIndex_page.vue?vue&type=script&lang=js"
export * from "./HKIndex_page.vue?vue&type=script&lang=js"
import style0 from "./HKIndex_page.vue?vue&type=style&index=0&id=563c2d17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c2d17",
  null
  
)

export default component.exports